import { Card, Row, Col, Timeline, Statistic } from "antd";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import classes from "./health.module.scss";
import { Typography } from "antd";

const { Title, Text } = Typography;

const BusinessHealth = () => {
  // Dummy KPIs
  const kpis = [
    { title: "Net Impact", value: "$156,000", suffix: "" },
    { title: "Threats Neutralized", value: 134, suffix: "" },
    { title: "Opportunities Captured", value: 87, suffix: "" },
    { title: "Learning Rate", value: 92, suffix: "%" },
  ];

  // Dummy Recent Actions
  const recentActions = [
    "Neutralized Cybersecurity Risk",
    "Captured Vendor Discount Opportunity",
    "Neutralized Unauthorized Access Attempt",
    "Captured SLA Optimization Opportunity",
    "Threat Detection Learning Improved",
  ];

  // Dummy Impact Over Time (Fake Growing Line)
  const impactOverTimeChart = {
    chart: { type: "line" },
    title: { text: "Impact Over Time" },
    xAxis: {
      categories: ["Week 1", "Week 2", "Week 3", "Week 4", "Week 5", "Week 6"],
    },
    yAxis: { title: { text: "Net Impact ($)" } },
    series: [
      { name: "Net Impact", data: [5000, 15000, 30000, 50000, 85000, 156000] },
    ],
  };

  return (
    <>
      {" "}
      <div className={classes.header}>
        <Title level={4} style={{ marginTop: 0 }}>
          Business Health
        </Title>
        <Text type="secondary" style={{ fontSize: 12 }}>
          Focus on wins, performance improvements, metrics like cost saved,
          risks reduced, etc.
        </Text>
      </div>
      <div style={{ padding: "20px" }}>
        {/* KPI Cards */}
        <Row gutter={[16, 16]}>
          {kpis.map((kpi, index) => (
            <Col span={6} key={index}>
              <Card>
                <Statistic
                  title={kpi.title}
                  value={kpi.value}
                  suffix={kpi.suffix}
                />
              </Card>
            </Col>
          ))}
        </Row>

        {/* Recent Actions Feed */}
        <Row style={{ marginTop: 30 }}>
          <Col span={24}>
            <Card title="Recent Major Actions">
              <Timeline mode="left">
                {recentActions.map((action, idx) => (
                  <Timeline.Item key={idx}>{action}</Timeline.Item>
                ))}
              </Timeline>
            </Card>
          </Col>
        </Row>

        {/* Impact Over Time Chart */}
        <Row style={{ marginTop: 30 }}>
          <Col span={24}>
            <Card title="Impact Over Time">
              <HighchartsReact
                highcharts={Highcharts}
                options={impactOverTimeChart}
              />
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};
export default BusinessHealth;
